import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const ReportBuilder = lazyWithRetry(() => import('./ReportBuilder'));

const ReportBuilderRoutes: React.FC<RouteComponentProps> = (props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="report-builder">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <ReportBuilder />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default ReportBuilderRoutes;
